import QueryString from 'query-string';
import { FetchService } from '.';

export default class ReportService extends FetchService {
  constructor() {
    super();

    this.get = this.get.bind(this);
    this.getTerminals = this.getTerminals.bind(this);
    this.getSumup = this.getSumup.bind(this);
  }

  get(query) {
    return this.Get('/reports?' + QueryString.stringify(query), { cache: 'no-store' })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  getTerminals(query) {
    return this.Get('/reports/terminals?' + QueryString.stringify(query), { cache: 'no-store' })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  getSumup(query) {
    return this.Get('/reports/terminals/sumup?' + QueryString.stringify(query), { cache: 'no-store' })
      .then((result) => {
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
